import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { createProduct, updateProduct } from "./productDetails";

const getConfig = () => {
    const token = store.getState().auth.token;

    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };

    return config;
};

export const getFilteredEntry =
    (
        start = "",
        end = "",
        page = 1,
        page_size = 20000,
        ProductLocation__Warehouse__id = "",
        ProductLocation__ProductDetails__Merchandiser__id = "",
        ProductLocation__ProductDetails__Category__id = "",
        keyword = "",
    ) =>
        async (dispatch) => {
            try {
                const response = await backend.get(
                    `api/product/productentryledger/?start=${start}&end=${end}&page=${page}&page_size=${page_size}&ProductLocation__Warehouse__id=${ProductLocation__Warehouse__id}&ProductLocation__ProductDetails__Merchandiser__id=${ProductLocation__ProductDetails__Merchandiser__id}&ProductLocation__ProductDetails__Category__id=${ProductLocation__ProductDetails__Category__id}&keyword=${keyword}`,
                    getConfig()
                );
                if (response.status === 200) {
                    dispatch({
                        type: types.GET_ALL_SINGLE_PRODUCT,
                        payload: response.data,
                    });
                    return response.data;
                }
            } catch (error) {
                console.log(error.response);
            }
        };



